// extracted by mini-css-extract-plugin
export default {"contents":"styles_contents__7cnTR","header":"styles_header__xHjfM","close":"styles_close__aQp+m","fade":"styles_fade__c2DR+"};